import { kMatterDraftsPath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { GetDraftsByMatterIdResponse, GetDraftsByMatterIdResponseSchema } from '@/drafting/schemas'
import { ApiError } from '@/util/errors/api-error'
import { getAuth } from 'firebase/auth'
import { nanoid } from 'nanoid'
import * as Sentry from '@sentry/browser'

export async function getDraftsByMatterId(matterId: string): Promise<GetDraftsByMatterIdResponse> {
  const sentryTransactionId = nanoid()

  try {
    const user = getAuth().currentUser
    if (!user) throw new Error('User not authenticated.')
    const token = await user.getIdToken()
    if (!token) throw new Error("Could not retrieve user's authentication token.")

    const apiUrl = `${kPaxtonAppApiRESTBaseUrl()}${kMatterDraftsPath.replace('{matterId}', matterId)}`

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Transaction-Id': sentryTransactionId,
        Authorization: `Bearer ${token}`,
      },
    })

    const data = await response.json()

    if (!response.ok) {
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentryTransactionId })
        Sentry.captureException(new Error(`Fetch error - status: ${response.status}`), {
          extra: { requestUrl: apiUrl, response: JSON.stringify(response), data: JSON.stringify(data) },
        })
      })
      throw new ApiError(response.status, `Fetch error - status: ${response.status}`)
    }

    return GetDraftsByMatterIdResponseSchema.parse(data)
  } catch (error) {
    if (!(error instanceof ApiError)) {
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentryTransactionId })
        Sentry.captureException(error, { extra: { onLine: navigator.onLine } })
      })
    }
    throw error
  }
}
